import React from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk"
import { useEffect } from "react"

function  FirstTab(props){

    const getToken = async () => {
  
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      };
      const response = await fetch("https://api.hom.edat.unicamp.br/superset/fetchOpenAccessGuestToken/" + props.dashboard_id , requestOptions)
      const token = await response.json()
      return token['token']
    }
  
    useEffect(() => {
      const embed = async () => {
        await embedDashboard({
          id: props.dashboard_id, // given by the Superset embedding UI
          supersetDomain: "https://indicadores.hom.edat.unicamp.br",
          // supersetDomain: 'https://api.dados.unicamp.br/superset',
          mountPoint: document.getElementById("dashboard"), // html element in which iframe render
          fetchGuestToken: () => getToken(),
          dashboardUiConfig: {
            hideTitle: true,
            hideChartControls: false,
            hideTab: true,
            filters: { "expanded": true, "visible": true } 
          },
        })
      }
      if (document.getElementById("dashboard")) {
        const iframeSuperset = document.getElementById("dashboard").children[0];
          if (iframeSuperset) {
              iframeSuperset.width = "100%";
              iframeSuperset.height = "100vh";
        }
        embed();
      }
    }, [])


    
  return (
    <div className="FirstTab">
      <div id="dashboard"  className="embedded-superset"/>
    </div>
  );
};
export default FirstTab;